export enum ModalEvent {
  OPEN_MODAL = "open_modal",
  EXIT = "exit",
}
